import React from 'react';
import { MetricGrid } from '../../../../shared/components/patterns';

export default function DocumentsStats({ stats, activeMetric, onMetricClick }) {
  const metrics = stats.map((metric) => ({
    ...metric,
    active: activeMetric === metric.id,
    onClick: onMetricClick ? () => onMetricClick(metric.id) : undefined,
  }));

  return <MetricGrid metrics={metrics} />;
}
